import { useAuth0 } from '@auth0/auth0-react'
import { useMemo, useState, useEffect } from 'react'

const decodeTokenPermissions = (token) => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]))
    return payload.permissions || []
  } catch {
    return []
  }
}

export const useAdminAuth = () => {
  const {
    user,
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout: auth0Logout,
    getAccessTokenSilently,
  } = useAuth0()

  const [tokenPermissions, setTokenPermissions] = useState([])

  useEffect(() => {
    if (!isAuthenticated) return
    getAccessTokenSilently()
      .then((token) => setTokenPermissions(decodeTokenPermissions(token)))
      .catch(() => setTokenPermissions([]))
  }, [isAuthenticated, getAccessTokenSilently])

  const isAdmin = useMemo(() => {
    if (!isAuthenticated) return false
    // Check access token permissions (set via Auth0 API RBAC settings)
    if (tokenPermissions.includes('admin:system')) return true
    // Fallback: check ID token custom claims (if Auth0 Action is configured)
    const idPermissions = user?.['https://api.carfile.app/permissions'] || []
    if (idPermissions.includes('admin:system')) return true
    const idRoles = user?.['https://api.carfile.app/roles'] || []
    if (idRoles.some(r => r.toLowerCase() === 'admin')) return true
    return false
  }, [isAuthenticated, tokenPermissions, user])

  const logout = () => {
    auth0Logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return {
    user,
    isAuthenticated,
    isAdmin,
    isLoading,
    loginWithRedirect,
    logout,
    getAccessTokenSilently,
  }
}
